<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { Check } from 'lucide-vue-next';
</script>

<template>
    <Button
        variant="ghost"
        size="xs"
    >
        <span>{{ $t('forms.activate') }}</span>
        <Check class="text-accent" />
    </Button>
</template>
